import React from 'react'

export const Calendar = () => {
    return (
        <div>
            Calendar
        </div>
    )
}
